import { z } from 'zod/v4';
import { SessionConcatStreamModes, SessionStreamModes, } from './channelSchema.js';
export const EventTypeSchema = z.union([
    z.literal('heartbeat'),
    z.literal('lifecycle'),
    z.literal('xmltv'),
    z.literal('settings-update'),
    z.literal('channel_schedule_changed'),
    z.literal('stream'),
    z.literal('empty_trash'),
]);
const BaseEventSchema = z.object({
    message: z.string().optional(),
    level: z.enum(['info', 'success', 'warning', 'error']),
});
export const SettingsUpdateEventSchema = BaseEventSchema.extend({
    type: z.literal('settings-update'),
    module: z.string(),
    detail: z.object({
        action: z.enum(['reset', 'update', 'action', 'delete', 'add']),
        error: z.string().optional(),
        serverName: z.string().optional(),
        serverId: z.string().optional(),
    }),
});
export const HeartbeatEventSchema = BaseEventSchema.extend({
    type: z.literal('heartbeat'),
});
export const XmlTvEventSchema = BaseEventSchema.extend({
    type: z.literal('xmltv'),
    module: z.string(),
    detail: z.object({
        time: z.number(),
    }),
});
export const LifecycleEventSchema = BaseEventSchema.extend({
    type: z.literal('lifecycle'),
    detail: z.object({
        time: z.number(),
    }),
});
export const StreamSessionEventSchema = BaseEventSchema.extend({
    type: z.literal('stream'),
    action: z.enum([
        'start',
        'connection_add',
        'connection_remove',
        'end',
        'error',
    ]),
    details: z.object({
        channelId: z.string().uuid(),
        sessionType: z.enum([...SessionStreamModes, ...SessionConcatStreamModes]),
    }),
});
export const ChannelScheduleChangedEventSchema = BaseEventSchema.extend({
    type: z.literal('channel_schedule_changed'),
    channelId: z.string().uuid(),
});
export const EmptyTrashEventSchema = BaseEventSchema.extend({
    type: z.literal('empty_trash'),
    detail: z.object({
        status: z.enum(['started', 'completed', 'cancelled', 'failed']),
        total: z.number(),
        deleted: z.number(),
    }),
});
export const TunarrEventSchema = z.discriminatedUnion('type', [
    SettingsUpdateEventSchema,
    HeartbeatEventSchema,
    LifecycleEventSchema,
    XmlTvEventSchema,
    StreamSessionEventSchema,
    ChannelScheduleChangedEventSchema,
    EmptyTrashEventSchema,
]);
//# sourceMappingURL=eventSchema.js.map